import CompleteAccountCta from '@components/atoms/buttons/CompleteAccountCta';
import GetStartedCta from '@components/atoms/buttons/GetStartedCta';
import { AccountStatus, AnalyticsScreenName } from 'mh-client';

const NavBarCta = ({
    accountStatus,
}: {
    accountStatus?: AccountStatus | null;
}) => {
    const menu = AnalyticsScreenName.getInstance().MENU;
    switch (accountStatus?.name) {
        case 'None':
        case 'Pending':
        case 'KycDeclined':
            return <GetStartedCta screenName={menu} />;
        case 'KycVerified':
            return (
                <CompleteAccountCta
                    id="topNav_CTA_completeSetUp"
                    screenName={menu}
                />
            );
        case 'Complete':
        default:
            return <></>;
    }
};

export default NavBarCta;
